export const featuresMap = (featArr: { feature: string; isActive: boolean }[]) => {
  const evalFeat = (value: string, defaultValue = true) => {
    const feat = featArr.find((el) => el.feature === value);
    return feat ? !!feat.isActive : defaultValue;
  };

  return {
    'app.mixpanel': evalFeat('app.mixpanel'),
    'app.wizard.popup(invert)': evalFeat('app.wizard.popup(invert)'),
    'app.partner.branding': evalFeat('app.partner.branding'),
    'app.help.page': evalFeat('app.help.page'),
    'review.iteration3': evalFeat('review.iteration3', false),
    'app.board-template': evalFeat('app.board-template'),
    'app.aiAssistant': evalFeat('app.aiAssistant'),
  };
};
